import { ToolkitListingID } from '@aloft/toolkit-shared';
import { UseQueryResult, useQueries } from '@tanstack/react-query';

import { useToolkitContext } from '../../../hooks/api/toolkitContext.ts';
import { useToolkitControllerGlobal } from '../useToolkitControllerGlobal.ts';
import { ListingResult } from './types.ts';

export const useGetListings = (listingIDs: ToolkitListingID[]): UseQueryResult<ListingResult>[] => {
  const { fetcherOptions } = useToolkitContext();
  const { mlsListingsBatcher } = useToolkitControllerGlobal();

  return useQueries({
    queries: listingIDs.map((listingID) => ({
      queryKey: ['C1Listing', listingID],
      queryFn: async () => mlsListingsBatcher.fetch(listingID, fetcherOptions),
      cacheTime: Infinity,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    })),
  });
};
